import { render } from "./DetailAnnonces.vue?vue&type=template&id=a41a536e&scoped=true"
import script from "./DetailAnnonces.vue?vue&type=script&lang=js"
export * from "./DetailAnnonces.vue?vue&type=script&lang=js"

import "./DetailAnnonces.vue?vue&type=style&index=0&id=a41a536e&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41a536e"]])

export default __exports__